export default __webpack_public_path__ + "static/media/arrowColor.f703b669.svg";